var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.453 1.45341C13.9463 0.946748 13.2663 0.666748 12.5597 0.666748H2.99967C1.53301 0.666748 0.333008 1.86675 0.333008 3.33341V24.6667C0.333008 26.1334 1.51967 27.3334 2.98634 27.3334H18.9997C20.4663 27.3334 21.6663 26.1334 21.6663 24.6667V9.77341C21.6663 9.06675 21.3863 8.38675 20.8797 7.89341L14.453 1.45341ZM14.9997 22.0001H6.99967C6.26634 22.0001 5.66634 21.4001 5.66634 20.6667C5.66634 19.9334 6.26634 19.3334 6.99967 19.3334H14.9997C15.733 19.3334 16.333 19.9334 16.333 20.6667C16.333 21.4001 15.733 22.0001 14.9997 22.0001ZM14.9997 16.6667H6.99967C6.26634 16.6667 5.66634 16.0667 5.66634 15.3334C5.66634 14.6001 6.26634 14.0001 6.99967 14.0001H14.9997C15.733 14.0001 16.333 14.6001 16.333 15.3334C16.333 16.0667 15.733 16.6667 14.9997 16.6667ZM12.333 8.66675V2.66675L19.6663 10.0001H13.6663C12.933 10.0001 12.333 9.40008 12.333 8.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionWhite);
export default __webpack_public_path__ + "static/media/descriptionWhite.d29b101d44bc82996d38d9582d223236.svg";
export { ForwardRef as ReactComponent };